<template>
  <b-tabs v-model="activeTabPlatform" :animated="false" @input="reloadIfSettings">
    <b-tab-item value="events" icon="calendar" :label="$t('events')">
      <EventsTable :events-collection="eventsCollection" :platform="true" />
    </b-tab-item>

    <b-tab-item value="events" icon="calendar" :label="$t('draftEvents')">
      <EventsTable :events-collection="draftEventsCollection" :platform="true" />
    </b-tab-item>

    <b-tab-item value="bills" icon="file-document-outline" :label="$t('allBills')">
      <BillsTable :bills-collection="billsCollection" :platform="true" />
    </b-tab-item>
    <b-tab-item value="organizations" :label="$t('organizations')" icon="domain">
      <OrganizationsTable :organizations-collection="organizationsCollection" />
    </b-tab-item>
    <b-tab-item value="admins" :label="$t('admins')" icon="account-outline">
      <AdminTable :admin-collection="adminCollection" :platform="true" />
    </b-tab-item>
    <b-tab-item value="translators" :label="$t('translators')" icon="translate">
      <TranslatorsTable :translators-collection="translatorsCollection" />
    </b-tab-item>
    <b-tab-item value="error" :label="$t('errors')" icon="alert-circle-outline">
      <DebugTable :log-collection="logCollection" />
    </b-tab-item>
    <b-tab-item value="clientError" :label="$t('clientErrors')" icon="account-network-outline">
      <ClientLogsTable :client-log-collection="clientLogCollection" />
    </b-tab-item>
    <b-tab-item value="blacklist" :label="$t('blacklist')" icon="domain-off">
      <BlacklistTable :blacklist-collection="blacklistCollection" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
import EventsTable from "@/components/EventsTable.vue";
import BillsTable from "@/components/BillsTable.vue";
import DebugTable from "@/components/DebugTable.vue";
import ClientLogsTable from "@/components/ClientLogsTable.vue";
import OrganizationsTable from "@/components/OrganizationsTable.vue";
import AdminTable from "@/components/AdminTable.vue";
import BlacklistTable from "@/components/BlacklistTable.vue";
import TranslatorsTable from "@/components/TranslatorsTable.vue";

import { db } from "@/firebase";

export default {
  name: "PlatformDashboardTabs",
  components: {
    EventsTable,
    BillsTable,
    DebugTable,
    OrganizationsTable,
    AdminTable,
    ClientLogsTable,
    BlacklistTable,
    TranslatorsTable,
  },
  data() {
    return {
      activeTabPlatform: this.$route.query.tab || localStorage.activeTabPlatform,
      events: [],
      bills: [],
      admins: [],
      organizations: [],
      logs: [],
      clientLogs: [],
      blacklist: [],
      translators: [],
    };
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId;
    },
    eventsCollection() {
      return db.collectionGroup("events").where("draft", "==", false);
    },
    draftEventsCollection() {
      return db.collectionGroup("events").where("draft", "==", true);
    },
    billsCollection() {
      return db.collectionGroup("bills");
    },
    blacklistCollection() {
      return db.collection("blacklist");
    },
    adminCollection() {
      return db.collection("platform_admins");
    },
    translatorsCollection() {
      return db.collection("member_translators");
    },
    logCollection() {
      return db.collection("logs");
    },
    clientLogCollection() {
      return db.collection("client_logs");
    },
    organizationsCollection() {
      return db.collection("organizations");
    },
    newAudioURL() {
      return URL.createObjectURL(this.newAudio);
    },
  },
  watch: {
    activeTabPlatform() {
      localStorage.activeTabPlatform = this.activeTabPlatform;
    },
  },
  created() {
    this.$store.commit("SET_ORGANIZATION_NAME", this.$t("platformDashboard"));
    this.$store.commit("CHANGE_COLOR_SCHEME", {
      primaryColor: "#122C2E",
      secondaryColor: "#122C2E",
    });
    this.$store.commit("CHANGE_LOGO", "/assets/qondalogo.svg");
  },
  methods: {
    reloadIfSettings(tabIndex) {
      if (tabIndex == "settings") {
        this.$store.dispatch("updateOrganizationId", this.organizationId);
      }
    },
  },
  firestore() {
    return {};
  },
};
</script>
